import {
	BackTop,
	Breadcrumb,
	Button,
	Card,
	Checkbox,
	Col,
	DatePicker,
	message,
	Row,
	Space,
	Spin,
	Table
} from "antd";
import Loader from "../../Common/Cred/Loader";
import constants from "../../../constants/constants";
import ReactQuill from "react-quill";
import { useEffect, useState } from "react";
import { fetchAdminApi } from "../../../services/api";
import { useHistory, } from "react-router";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
const Notices = () => {
	const [loading, setLoading] = useState(false);
	const [dataSource, setDataSource] = useState([]);
	const [editableData, setEditableData] = useState([]);
	let history = useHistory();
	useEffect(() => {
		settingsData();
	}, []);
	const settingsData = () => {
		setLoading(true);
		fetchAdminApi('/get-settings-details', "GET")
			.then((res) => {
				if (res.code === 200) {
					setLoading(false);
					setDataSource(res.data);
					setEditableData(res.data.map((item) => ({ ...item })));
				} else {
					setLoading(false);
					setDataSource([]);
					message.error(res.message);
				}
			});
	};
	const columns = [
		{
			title: "#",
			dataIndex: "settings_id",
			width: "2%",
		},
		{
			title: "Notice name",
			dataIndex: "settings_name",
			width: "5%",
			render: (text, record) => {
				return (
					<div className="d-flex-wrap flex-vertical-middle gap-2">
						<span>
							{text}
							{record.settings_info && (
								<Tooltip title={record.settings_info}>
									<InfoCircleOutlined style={{ marginLeft: 6 }}/>
								</Tooltip>
							)}
						</span>
					</div>
				);
			}
		},
		{
			title: "Message",
			dataIndex: "message",
			width: "46%",
			render: (_text, _record, index) =>
				<ReactQuill
					className="border-spacing-0 w-auto"
					theme="snow"
					value={editableData[index]?.message || ""}
					onChange={(value) => handleMessageChange(value, index)}
					placeholder=""
					modules={constants.ReactQuillModules}
					formats={constants.ReactQuillFormats}
				/>,
		},
		{
			title: "Enable",
			dataIndex: "is_enabled",
			align: "center",
			width: "4%",
			render: (_text, _record, index) => (
				<Checkbox className="border-spacing-0" checked={editableData[index]?.is_enabled === "t"} onChange={(e) => {
					const newData = [...editableData];
					newData[index].is_enabled = e.target.checked ? "t" : "f";
					setEditableData(newData);
				}}/>
			),
		},
		{
			title: "Start Date",
			dataIndex: "start_date",
			width: "9%",
			render: (_text, _record, index) => (
				<DatePicker
					showTime
					format="MM/DD/YYYY HH:mm"
					className="tw-w-full"
					value={
						editableData[index]?.start_date
							? moment(editableData[index].start_date)
							: null
					}
					onChange={(date) => {
						const newData = [...editableData];
						newData[index].start_date = date
							? date.format("YYYY-MM-DD HH:mm")
							: null;
						setEditableData(newData);
					}}
				/>
			),
		},
		{
			title: "End Date",
			dataIndex: "end_date",
			width: "9%",
			render: (_text, _record, index) => (
				<DatePicker
					showTime
					format="MM/DD/YYYY HH:mm"
					className="tw-w-full"
					value={
						editableData[index]?.end_date
							? moment(editableData[index].end_date, "YYYY-MM-DD HH:mm")
							: null
					}
					onChange={(date) => {
						const newData = [...editableData];
						newData[index].end_date = date
							? date.format("YYYY-MM-DD HH:mm")
							: null;
						setEditableData(newData);
					}}
				/>
			),
		},
		{
			title: "Updated On",
			dataIndex: "dt_updated",
			width: "5%",
			render: (dt_updated) => (
				<span>
					{dt_updated ? moment(dt_updated).format("MM/DD/YYYY") : "-"}
				</span>
			),
		},
	];
	const handleMessageChange = (value, index) => {
		const updatedData = [...editableData];
		if (!updatedData[index]) return;
		updatedData[index].message = value;
		setEditableData(updatedData);
	};
	const handleSave = () => {
		setLoading(true);
		const changedRows = editableData.filter((editedRow, index) => {
			const originalRow = dataSource[index];
			return (
				editedRow.message !== originalRow.message ||
        editedRow.is_enabled !== originalRow.is_enabled ||
				editedRow.start_date !== originalRow.start_date ||
				editedRow.end_date !== originalRow.end_date
			);
		});
		const payload = changedRows.map(({ settings_id, message, is_enabled, start_date, end_date, }) => ({
			settings_id,
			message,
			is_enabled,
			start_date,
			end_date,
		}));
		fetchAdminApi('/update-settings-details', "POST", payload)
			.then((res) => {
				if (res.code === 200) {
					setLoading(false);
					message.success(res.message);
					settingsData();
				} else {
					setLoading(false);
					message.error(res.message);
				}
			});
	};
	return (
		<>
			<Spin size="large" spinning={false} indicator={<Loader/>}>
				<div className="div">
					<div className="p-3">
						<Breadcrumb>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/admin-dashboard" });
									}}
								>{constants.Home}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>
								<a
									onClick={() => {
										history.push({ pathname: "/masters-menu" });
									}}
								>{constants.Masters}
								</a>
							</Breadcrumb.Item>
							<Breadcrumb.Item>{constants.Notices}</Breadcrumb.Item>
						</Breadcrumb>
					</div>
					<BackTop/>
					<Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Card
								size="small"
								title={
									<span className="text-uppercase">{constants.Notices}</span>
								}
							>
								<Row gutter={[24, 24]}>
									<Col xs={24} sm={24} md={24} lg={24}>
										<>
											<Table
												rowKey="settings_id"
												className="admin-gap-table table-content-top"
												columns={columns}
												dataSource={dataSource}
												pagination={false}
												locale={{ emptyText: "No Records Found" }}
											/>
										</>
									</Col>
								</Row>
								<div className="w-full flex justify-end mr-4 mt-3">
									<Space>
										<Button
											type="primary"
											className="navy-btn"
											loading={loading}
											onClick={handleSave}
										>
											{constants.Save}
										</Button>
										<Button
											onClick={()=>history.push("/masters-menu")}
										>
											{constants.CancelBTN}
										</Button>
									</Space>
								</div>
							</Card>
						</Col>
					</Row>
				</div>
			</Spin>
		</>
	);
};
export default Notices;
